"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Pricing_1 = require("../Pricing");
class CreativeFormatPlacement {
    constructor({ id, key, name, basicMerchandises, }) {
        this.toJSON = () => ({
            id: this.id,
            key: this.key,
            name: this.name,
            basicMerchandises: this.basicMerchandises,
        });
        this.id = id;
        this.key = key;
        this.name = name;
        this.basicMerchandises = basicMerchandises;
    }
}
CreativeFormatPlacement.fromJSON = (json) => {
    const { id, key, name, basicMerchandises } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof key !== 'string')
        throw new Error('.key must be a string');
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    return new CreativeFormatPlacement({
        id,
        key,
        name,
        basicMerchandises: basicMerchandises
            ? basicMerchandises.map((_basicMerchandise) => Pricing_1.PricingMerchandiseBasic.fromJSON(_basicMerchandise))
            : undefined,
    });
};
exports.default = CreativeFormatPlacement;
